<div [formGroup]="checkboxForm">
    <div formArrayName="checkboxGroup">
        <div *ngFor="let option of checkboxForm.get('checkboxGroup')['controls']; let i = index">
            <div [formGroupName]="i">
                <mat-checkbox formControlName="selected" (change)="onSelectionChanged(option)" color="primary">
                    {{ option.controls.name.value }}
                </mat-checkbox>
            </div>
        </div>
    </div>
</div>
